export default "__VITE_ASSET__B1gy33kp__"